<script setup lang="ts">
import AktualnoscCardSliderComponent from '~/components/AktualnoscCardSliderComponent.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Sliders/Media o nas'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}

const component_default_values_2: CmsCustomComponentType = {
  poster: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'image', setting_label: 'zmien poster' },
  video: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'video', setting_label: 'zmien video' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="py-10 flex flex-col gap-8 xl:gap-16 bg-background-1 px-2xl"
    >
      <div class="flex flex-col gap-7.5">
        <span class="text-Tekst text-H2">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
          />
        </span>
        <span class="text-Tekst text-H4">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
          />
        </span>
      </div>
      <CmsCustomComponentList
        v-slot="{ component_values: componentListValues }"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'list']"
        :defaults="component_default_values_2"
        :open-options="true"
        component-name="list"
      >
        <AktualnoscCardSliderComponent
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data']"
          :data-length="componentListValues.length"
          :data="componentListValues"
        />
      </CmsCustomComponentList>
    </div>
  </CmsCustomComponent>
</template>
